export default function ChartFallBack() {
  return (
    <>
      <div className="fallbackChart">
        <span>Chart Visuals Not Generated In Required Format!</span>
      </div>
    </>
  );
}
